import axios from "const/axios";

const base = "/college-documents";

export const listFolders = async (universityId) => {
  const response = await axios.get(`${base}/folders`, { params: { universityId } });
  return response.data;
};

export const createFolder = async ({ universityId, parentId, name }) => {
  const response = await axios.post(`${base}/folders`, { universityId, parentId, name });
  return response.data;
};

/** Rename and/or move. `moveRequested` must be true to move, including a move to the root. */
export const updateFolder = async (folderId, { name, parentId, moveRequested = false }) => {
  const response = await axios.patch(`${base}/folders/${folderId}`, {
    name,
    parentId,
    moveRequested,
  });
  return response.data;
};

export const deleteFolder = async (folderId) => {
  await axios.delete(`${base}/folders/${folderId}`);
};

export const listFiles = async (universityId, folderId) => {
  const response = await axios.get(`${base}/files`, { params: { universityId, folderId } });
  return response.data;
};

export const uploadFile = async ({ universityId, folderId, name, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  if (name) formData.append("name", name);
  const response = await axios.post(`${base}/files`, formData, {
    params: { universityId, folderId },
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const updateFile = async (fileId, { name, folderId, active }) => {
  const response = await axios.patch(`${base}/files/${fileId}`, { name, folderId, active });
  return response.data;
};

export const deleteFile = async (fileId) => {
  await axios.delete(`${base}/files/${fileId}`);
};

export const previewFile = async (fileId) => {
  const response = await axios.get(`${base}/files/${fileId}/preview`);
  return response.data;
};

export const searchLibrary = async ({ universityId, folderId, q }) => {
  const response = await axios.get(`${base}/search`, { params: { universityId, folderId, q } });
  return response.data;
};

/** Field mapping for one file: page previews plus its current field list. */
export const getMapping = async (fileId) => {
  const response = await axios.get(`${base}/files/${fileId}/mapping`);
  return response.data;
};

/**
 * The fields the PDF's own form already declares, with their real rectangles. Read-only: the
 * mapping page loads these into its editor and they persist only when the admin saves.
 */
export const detectFields = async (fileId) => {
  const response = await axios.post(`${base}/files/${fileId}/detect-fields`);
  return response.data;
};

export const saveMapping = async (fileId, fields) => {
  const response = await axios.put(`${base}/files/${fileId}/mapping`, fields);
  return response.data;
};

/** The catalog of linked-detail keys (client.*, bank.*, …) fields can be auto-filled from. */
export const listPrefillKeys = async () => {
  const response = await axios.get(`${base}/prefill-keys`);
  return response.data;
};

/** This college's other files that already have a mapping, candidates to copy from. */
export const listCopySources = async (fileId) => {
  const response = await axios.get(`${base}/files/${fileId}/copy-sources`);
  return response.data;
};

export const copyMapping = async (fileId, sourceFileId) => {
  const response = await axios.post(`${base}/files/${fileId}/copy-mapping`, { sourceFileId });
  return response.data;
};

/** Client picker for the send dialog: name, email or passport number, this org only. */
export const searchSendClients = async (q) => {
  const response = await axios.get(`${base}/client-search`, { params: { q } });
  return response.data;
};

export const sendCollegeDocuments = async (payload) => {
  const response = await axios.post(`${base}/send`, payload);
  return response.data;
};

/** Paginated tracking list of every document sent for signing, filterable and searchable. */
export const listSends = async (params) => {
  const response = await axios.get(`${base}/sends`, { params });
  return response.data;
};
